import { FC, ReactNode } from "react";
import { AnalyticsProvider } from "~context/analyticsContext";
import { useCookieConsent } from "~context/cookieConsentContext";
import {
  GoogleAnalyticsScript,
  GoogleTagManagerScript,
  FixedGoogleTagManagerScripts,
  HotjarScript,
} from "~features/tracking/analytics/integrations";
import { useOrganization } from "~hooks/useOrganization";
import { OrganizationFeatures } from "~lib/features";

interface AnalyticsConsentProviderProps {
  children: ReactNode;
  gtmId?: string;
}

export const AnalyticsConsentProvider: FC<AnalyticsConsentProviderProps> = ({
  children,
  gtmId,
}) => {
  const { isAnalyticsAllowed } = useCookieConsent();
  const { hasFeature } = useOrganization();
  const enableAnalytics = hasFeature(OrganizationFeatures.CookieConsent)
    ? isAnalyticsAllowed()
    : true;

  if (enableAnalytics) {
    return (
      <AnalyticsProvider>
        <GoogleAnalyticsScript />
        <HotjarScript />
        <GoogleTagManagerScript containerId={gtmId} />
        <FixedGoogleTagManagerScripts />
        {children}
      </AnalyticsProvider>
    );
  }

  return <>{children}</>;
};
